import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './primary-button.css'

const PrimaryButton = ({ label, fluid, disabled, onClick }) => {
  const className = classNames({
    'primary-button': !fluid,
    'primary-button-fluid': fluid,
    'is-disabled': disabled,
  })

  return (
    <button styleName={className} onClick={disabled ? null : onClick}>
      {label}
    </button>
  )
}

PrimaryButton.propTypes = {
  disabled: PropTypes.bool,
  fluid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default CSSModules(PrimaryButton, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/primary-button/primary-button.js
 **/